import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import * as securityService from '@/apis/securityService'

import piniaPersistConfig from './helper/persist'
import type { Menu, Permission } from './interface/securityStore.d'

export const useSecurityStore = defineStore(
  'securityStore',
  () => {
    const menus = ref<Menu[] | null>(null)
    const permissions = ref<Permission[] | null>(null)

    const getterMenus = computed(() => {
      return menus.value
    })

    const getterPermissions = computed(() => {
      return permissions.value
    })

    const generateMenus = async (): Promise<void> => {
      try {
        const res = await securityService.getMenus()
        menus.value = res
        console.log('got menus', res)
      } catch (error) {
        console.error('generateMenus error', error)
        return Promise.reject(error)
      }
    }

    const generatePermissions = async (): Promise<void> => {
      try {
        const res = await securityService.getPermissions()
        permissions.value = res
        console.log('got permissions', res)
      } catch (error) {
        console.error('generatePermissions error', error)
        return Promise.reject(error)
      }
    }

    const clear = (): Promise<void> => {
      menus.value = null
      permissions.value = null
      return Promise.resolve()
    }

    return {
      menus,
      permissions,
      getterMenus,
      getterPermissions,
      generateMenus,
      generatePermissions,
      clear
    }
  },
  {
    persist: piniaPersistConfig('securityStore')
  }
)
